const courses_es = require('./courses.json')
export default courses_es